"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = __importDefault(require("../../styles/styles"));
const defaultProps = {
    children: null,
    text: '',
};
const FieldErrorMessage = ({ children, text }) => {
    return text ? (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginLeftTen] },
        react_1.default.createElement(react_native_1.Text, { style: styles_1.default.textError }, text))) : (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginLeftTen] },
        react_1.default.createElement(react_native_1.Text, { style: styles_1.default.textError }, children)));
};
FieldErrorMessage.defaultProps = defaultProps;
exports.default = FieldErrorMessage;
